import {
  APP_LAYOUT_SET_SELECTED_MENU,
  APP_LAYOUT_SET_COMPANY_DETAILS,
  APP_LAYOUT_SET_PLAN_DETAILS,
  APP_LAYOUT_SET_ELIGIBILITY_DETAILS,
  GLOBAL_TOAST_MESSAGE,
  GLOBAL_USER_ROLE_CONFIGURATION,
} from "./actions";
import { get } from "lodash-es";

const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case GLOBAL_USER_ROLE_CONFIGURATION:
      return {
        ...state,
        userRole: payload,
      };
    case APP_LAYOUT_SET_SELECTED_MENU:
      return {
        ...state,
        selectedMenu: payload,
      };
    case GLOBAL_TOAST_MESSAGE: {
      return {
        ...state,
        showToast: get(payload, "showToast", false),
        toastMessage: get(payload, "toastMessage", ""),
        // toastMessage2: get(payload, "toastMessage2", ""),
        // toastMessage1: get(payload, "toastMessage1", ""),
        // reject: get(payload, "reject", false),
      };
    }
    case APP_LAYOUT_SET_COMPANY_DETAILS:
      return {
        ...state,
        companyDetails: payload,
      };
    case APP_LAYOUT_SET_PLAN_DETAILS:
      return {
        ...state,
        planDetails: payload,
      };
    case APP_LAYOUT_SET_ELIGIBILITY_DETAILS:
      return {
        ...state,
        eligibilityDetails: payload,
      };
    default:
      return state;
  }
};

export default reducer;
